<template>
<!--pc主页面 过渡页面 -->
<div class='pc'>
   <!-- 面包屑导航 -->
    <Breadcrumb></Breadcrumb>
  <div class='index_main'>
  <router-view></router-view>
  </div>
</div>

</template>

<script>
import Breadcrumb from '../common/breadcrumb/Breadcrumb';
export default {
  name:'pc_index',
  components:{
    Breadcrumb
  }
};
</script>

<style>

</style>